var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStep3ChoosePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F3F3E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2925_7667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.38 53.97C18.36 53.91 18.35 53.84 18.33 53.78L14.02 34.54C13.42 31.88 15.1 29.25 17.75 28.65L51.8 21.02C54.46 20.42 57.09 22.1 57.69 24.75L58.24 27.2",
    stroke: "#B0ADAD",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6401 30.3601H25.7401C23.0173 30.3601 20.8101 32.5673 20.8101 35.2901V55.0101C20.8101 57.7329 23.0173 59.9401 25.7401 59.9401H60.6401C63.3628 59.9401 65.5701 57.7329 65.5701 55.0101V35.2901C65.5701 32.5673 63.3628 30.3601 60.6401 30.3601Z",
    stroke: "#B0ADAD",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.76 37.1299H65.32",
    stroke: "#B0ADAD",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4499 51.5601C33.6699 52.3001 32.6399 52.7401 31.4899 52.7401C29.0999 52.7401 27.1699 50.8101 27.1699 48.4201C27.1699 46.0301 29.0999 44.1001 31.4899 44.1001C32.6399 44.1001 33.6799 44.5501 34.4499 45.2801",
    stroke: "#B0ADAD",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4001 52.7301C39.7859 52.7301 41.7201 50.796 41.7201 48.4101C41.7201 46.0242 39.7859 44.0901 37.4001 44.0901C35.0142 44.0901 33.0801 46.0242 33.0801 48.4101C33.0801 50.796 35.0142 52.7301 37.4001 52.7301Z",
    stroke: "#B0ADAD",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2925_7667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.46,
    height: 40.84,
    fill: "white",
    transform: "translate(13 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStep3ChoosePlan);
export default __webpack_public_path__ + "static/media/icon_step3_choose_plan.edac9e549bfd1af8ac514ee31a67d4fb.svg";
export { ForwardRef as ReactComponent };